import * as THREE from 'three';
import {
  CARD1Web,
} from '../../CoordUtils.js';

import {
  ModelLoader
} from '@/drawings3D/ModelLoader';

//这个类用来载入路牌所需要的各种贴图，使用canvas实现
export class Car1Loader extends ModelLoader {
  constructor(monitorOption, sceneManager) {
  	var modelInfo = {
        modelPath: '/static/bimroad/3DModels/car1/',
        name: 'car1',
        extraPartConfig:{
          option:monitorOption
        }
      }
    super(sceneManager, modelInfo);
  }

  loadExtraParts(extraPart, loadedMesh) {
     loadedMesh.oInfo = extraPart.option.option.info;
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/DirectModel/Car1Loader.js